"use client"
import PBPavilion from "./PBPavilion"

export default function Home() {
  return <PBPavilion />
}